import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

const VISITOR_ID_KEY = 'analytics_visitor_id';
const SESSION_ID_KEY = 'analytics_session_id';
const SESSION_EXPIRY = 30 * 60 * 1000; // 30 minutes

export function useRealtimeAnalytics() {
    const location = useLocation();
    const initialized = useRef(false);

    useEffect(() => {
        const trackPageView = async () => {
            // 1. Get or create Visitor ID
            let visitorId = localStorage.getItem(VISITOR_ID_KEY);
            if (!visitorId) {
                visitorId = uuidv4();
                localStorage.setItem(VISITOR_ID_KEY, visitorId);
            }

            // 2. Get or create Session ID
            let sessionId = sessionStorage.getItem(SESSION_ID_KEY);
            if (!sessionId) {
                sessionId = uuidv4();
                sessionStorage.setItem(SESSION_ID_KEY, sessionId);
            }

            // 3. Send tracking event
            try {
                await fetch('/api/analytics/track', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        visitorId,
                        sessionId,
                        url: window.location.href,
                        path: location.pathname,
                        referrer: document.referrer
                    }),
                });
            } catch (error) {
                console.error('Failed to track page view:', error);
            }
        };

        trackPageView();
    }, [location.pathname]); // Track on route change
}
